import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
// import { setDrawerOpen, setMapMode } from '../../../../redux/slices/sahelSlice';
import useMapActions from '../../hooks/MapActions';
import { MapMode } from '../../types';
import { useTranslation } from 'next-i18next';
import { logEvent } from '../../../../new-lib/analytics';
import { getPageLocation } from '../../../../helpers/common';
import { useRouter } from 'next/router';
import CalculateDistanceIcon from '../../../../new-components/svg-icons/CalculateDistanceIcon';
import { setDrawerOpen, setMapMode } from '../../../../redux/slices/mapSlice';

const CalculateDistanceButton = () => {
  const { asPath } = useRouter();

  const { t } = useTranslation('map');

  const isMobile = useSelector((state: any) => state.app.isMobile);

  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);

  const dispatch = useDispatch();

  const { selectCompound } = useMapActions();

  const handleClick = () => {
    dispatch(setMapMode(MapMode.CalculateDistance));

    if (selectedCompound) {
      selectCompound(selectedCompound.id);
    }

    if (isMobile) {
      dispatch(setDrawerOpen(false));
    } else if (!drawerOpen) {
      dispatch(setDrawerOpen(true));
    }

    logEvent.click(
      'map_calculate_distance',
      getPageLocation(asPath),
      'map',
      {
        sahel_distance_checked: true
      }
    );
  };

  return (
    <Container>
      <div className="btn-container" onClick={handleClick}>
        <CalculateDistanceIcon stroke={isMobile ? '#4B535F' : '#015c9a'} />

        {!isMobile && <span>{t('calculate_distance')}</span>}
      </div>
    </Container>
  );
};

const Container = styled.button`
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 16px;
  background-color: #fff;
  color: #015c9a;
  font-size: 15px;
  font-family: materialMedium;
  border-radius: 360px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  border: none;

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 40px;
    height: 40px;
    padding: 0;
  }
`;

export default CalculateDistanceButton;
